__turbopack_context__.v({
  "header": "header-module-scss-module__zaIvda__header",
  "input-container": "header-module-scss-module__zaIvda__input-container",
  "part-one": "header-module-scss-module__zaIvda__part-one",
  "scrolled": "header-module-scss-module__zaIvda__scrolled",
  "top-app-bar": "header-module-scss-module__zaIvda__top-app-bar",
  "week-name": "header-module-scss-module__zaIvda__week-name",
  "week-names-container-mobile": "header-module-scss-module__zaIvda__week-names-container-mobile",
  "week-names-container-mobile__default": "header-module-scss-module__zaIvda__week-names-container-mobile__default",
});
